// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3nq1W","Success":"Button_Success__2NgWP","Danger":"Button_Danger__cHKJp"};